import React from 'react';
import TelaEmManutencao from './components/TelaEmManutencao';

export default function LiberacaoKits() {
  return (
    <TelaEmManutencao
      icone="📦"
      titulo="Liberação dos Kits"
      descricao="Controle de liberação dos kits para os pacientes. Esta funcionalidade está em manutenção e será disponibilizada em breve."
    />
  );
}
